var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6074 13.3031H16.6406V14.8729H16.6836C17.1074 14.1116 18.1387 13.3031 19.6797 13.3031C22.8809 13.3031 23.4727 15.3046 23.4727 17.9085V23.4145H20.3105V18.5207C20.3105 17.4003 20.2871 15.958 18.666 15.958C17.0449 15.958 16.7676 17.1766 16.7676 18.4402V23.4243H13.6074V13.3031ZM11.8125 10.2381C11.8125 10.5649 11.7161 10.8843 11.5353 11.156C11.3546 11.4277 11.0978 11.6395 10.7973 11.7646C10.4968 11.8896 10.1661 11.9223 9.84714 11.8586C9.52813 11.7948 9.2351 11.6375 9.00511 11.4064C8.77512 11.1753 8.61849 10.881 8.55504 10.5605C8.49158 10.24 8.52415 9.90776 8.64862 9.60587C8.77309 9.30397 8.98387 9.04593 9.25432 8.86438C9.52476 8.68284 9.84271 8.58594 10.168 8.58594C10.604 8.58646 11.022 8.76069 11.3303 9.07043C11.6386 9.38016 11.812 9.8001 11.8125 10.2381ZM8.52734 13.3031H11.8125V23.4145H8.52734V13.3031Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInSvg);
export default __webpack_public_path__ + "static/media/linkedInSVG.c5e1c4d48a2c33a2cd28faf34a4aa1f5.svg";
export { ForwardRef as ReactComponent };